import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const ClientPagination = ({ currentPage, totalPages, paginate, filteredUsers, clientsPerPage, indexOfFirstClient, indexOfLastClient}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      {/* Info text */}
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Showing <span className="font-medium text-gray-900 dark:text-white">{indexOfFirstClient + 1}</span> to{" "}
        <span className="font-medium text-gray-900 dark:text-white">{Math.min(indexOfLastClient, filteredUsers.length)}</span> of{" "}
        <span className="font-medium text-gray-900 dark:text-white">{filteredUsers.length}</span> clients
      </p>

      {/* Pagination controls */}
      {filteredUsers.length > clientsPerPage && (
        <div className="flex items-center gap-1">
          {/* Previous button */}
          <button
            onClick={() => paginate(currentPage > 1 ? currentPage - 1 : currentPage)}
            disabled={currentPage === 1}
            className={`p-2 rounded-lg transition-all ${
              currentPage === 1
                ? "text-gray-300 dark:text-dark-600 cursor-not-allowed"
                : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700"
            }`}
          >
            <FaChevronLeft className="w-4 h-4" />
          </button>

          {/* Page numbers */}
          {Array.from({ length: totalPages }, (_, i) => {
            if (
              i === 0 ||
              i === totalPages - 1 ||
              (i >= currentPage - 2 && i <= currentPage + 2)
            ) {
              return (
                <button
                  key={i + 1}
                  onClick={() => paginate(i + 1)}
                  className={`min-w-[36px] h-9 px-3 rounded-lg text-sm font-medium transition-all ${
                    i + 1 === currentPage
                      ? "bg-primary-600 text-white shadow-lg"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700"
                  }`}
                >
                  {i + 1}
                </button>
              );
            }
            if (i === currentPage - 3 || i === currentPage + 3) {
              return (
                <span key={i} className="px-2 text-gray-400">...</span>
              );
            }
            return null;
          })}

          {/* Next button */}
          <button
            onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : currentPage)}
            disabled={currentPage === totalPages}
            className={`p-2 rounded-lg transition-all ${
              currentPage === totalPages
                ? "text-gray-300 dark:text-dark-600 cursor-not-allowed"
                : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700"
            }`}
          >
            <FaChevronRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientPagination;